import { buildProps as o } from "./index601.js";
const p = o({
  total: {
    type: Number,
    default: 1e3
  }
});
export {
  p as paginationTotalProps
};
